import { generateClient } from 'aws-amplify/api';
import './appsyncClient';

const TRANSCRIPTION_ENDPOINT =
  'https://om4ntpcxzjc3zpyagwytsx7xiy.appsync-api.us-east-2.amazonaws.com/graphql';
const TRANSCRIPTION_REGION = 'us-east-2';
const TRANSCRIPTION_API_KEY = 'da2-25f2he33ibgxlpwegjxzyjmpcq';

export const transcriptionClient = generateClient({
  endpoint: TRANSCRIPTION_ENDPOINT,
  region: TRANSCRIPTION_REGION,
  authMode: 'apiKey',
  apiKey: TRANSCRIPTION_API_KEY,
});
